import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [role, setRole] = useState("tourist");
  const [loading, setLoading] = useState(false);
  const { registerWithPassword } = useAuth();
  const navigate = useNavigate();

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await registerWithPassword({ email, password, name, role });
      toast.success("Welcome to IndoVoyage!");
      if (u.role === "vendor") navigate("/vendor/onboarding", { replace: true });
      else navigate("/", { replace: true });
    } catch (err) { toast.error(err?.response?.data?.detail || "Could not register"); }
    setLoading(false);
  };

  return (
    <div className="min-h-[75vh] flex items-center justify-center px-4 py-12" data-testid="register-page">
      <div className="w-full max-w-md rounded-3xl bg-card border border-border p-8 shadow-[0_10px_30px_-18px_rgba(31,42,68,0.25)]">
        <h1 className="font-display text-3xl font-semibold tracking-tight">Create your account</h1>
        <p className="text-sm text-muted-foreground mt-1">Join to plan your India trip with local experts.</p>

        <Button type="button" variant="secondary" className="mt-5 w-full rounded-xl h-11" onClick={googleLogin} data-testid="auth-google-button">
          <svg className="h-4 w-4 mr-2" viewBox="0 0 24 24" fill="currentColor"><path d="M21.35 11.1h-9.17v2.73h6.51c-.33 3.81-3.5 5.44-6.5 5.44C8.36 19.27 5 16.25 5 12c0-4.1 3.2-7.27 7.2-7.27 3.09 0 4.9 1.97 4.9 1.97L19 4.72S16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12c0 5.05 4.13 10 10.22 10 5.35 0 9.25-3.67 9.25-9.09 0-1.15-.15-1.81-.15-1.81z"/></svg>
          Sign up with Google
        </Button>

        <div className="flex items-center gap-3 my-5"><div className="h-px bg-border flex-1" /><span className="text-xs text-muted-foreground">or with email</span><div className="h-px bg-border flex-1" /></div>

        <form onSubmit={submit} className="grid gap-3">
          <label className="text-sm">Full name
            <Input required value={name} onChange={(e) => setName(e.target.value)} className="mt-1" data-testid="register-name-input" />
          </label>
          <label className="text-sm">Email
            <Input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1" data-testid="register-email-input" />
          </label>
          <label className="text-sm">Password
            <Input required type="password" minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1" data-testid="register-password-input" />
          </label>
          <div className="text-sm">I am a
            <div className="mt-1 grid grid-cols-2 gap-2">
              <button type="button" onClick={() => setRole("tourist")} className={`rounded-xl border py-2 text-sm ${role === "tourist" ? "bg-[hsl(var(--primary))] text-white border-transparent" : "bg-card border-border"}`} data-testid="role-tourist">Traveler</button>
              <button type="button" onClick={() => setRole("vendor")} className={`rounded-xl border py-2 text-sm ${role === "vendor" ? "bg-[hsl(var(--primary))] text-white border-transparent" : "bg-card border-border"}`} data-testid="role-vendor">Vendor</button>
            </div>
          </div>
          <Button type="submit" disabled={loading} className="rounded-xl h-11 mt-2" data-testid="register-submit-button">{loading ? "Creating…" : "Create account"}</Button>
        </form>

        <p className="mt-5 text-sm text-center">Already have an account? <Link to="/auth/login" className="text-[hsl(var(--primary))] font-medium">Log in</Link></p>
      </div>
    </div>
  );
}
